






























import Vue from "vue";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";

import IconCardTyping from "@joyz/app-core/assets/icons/transparent/DrillTyping.svg";
import IconCorrect from "@joyz/app-core/assets/icons/Correct.svg";
import IconIncorrect from "@joyz/app-core/assets/icons/Incorrect.svg";
import IconSkipped from "@joyz/app-core/assets/icons/misc/DrillSkip.svg";
import IconSpeaker from "@joyz/app-core/assets/icons/default/Speaker.svg";
import { audioContext } from "@tt-app/utils/audio/audioContext";

interface Data {
  icons: { [key: string]: string };
}

export default Vue.extend<Data, any, any, any>({
  name: "TranslationReviewSummaryItem",

  props: {
    audioDecoderPlayer: { type: AudioDecoderPlayer, default: undefined },
    exercise: { type: Object, default: () => ({}) },
    questionIndex: { type: Number, default: 0 }
  },

  data() {
    return {
      icons: {
        correct: IconCorrect,
        drillType: IconCardTyping,
        incorrect: IconIncorrect,
        skipped: IconSkipped,
        speaker: IconSpeaker
      }
    };
  },

  methods: {
    async playAudio() {
      if (this.audioDecoderPlayer.status === "playing") {
        this.audioDecoderPlayer.stop();
      }

      await audioContext.resume();
      await this.audioDecoderPlayer.play(this.exercise.question.scope.audioUrl);
    }
  },

  computed: {
    accurate() {
      return this.exercise.question.evaluatedAnswer.isCorrect;
    },

    accuracyIcon() {
      let icon = this.icons.skipped;

      if (this.accurate !== null) {
        icon = this.accurate ? this.icons.correct : this.icons.incorrect;
      }

      return icon;
    },

    correctAnswer() {
      return this.exercise.question.evaluatedAnswer.correctAnswer.text;
    },

    userAnswer() {
      return this.exercise.question.evaluatedAnswer.submittedAnswer || "–";
    },

    word() {
      return this.exercise.question.prompt;
    }
  }
});
